<template>
  <slick :options='slickOptions' class='sliderArticles' ref='sliderArticles'>
    <div class="sliderArticles--slide" v-for="item in informes3" :key="item.title">
      <h1 class="sliderArticles--slideTitle">Informes III</h1>
      <ArticleMain
      :titleResume='item.titleResume'
      :title='item.title'
      :text='item.text'
      :linkPT='item.linkPT'
      :linkES='item.linkES'
      :linkIN='item.linkIN'
      :imgFull='item.imgFull'
      :imgLarge='item.imgLarge'
      :imgMedium='item.imgMedium'
      :imgSmall='item.imgSmall'/>
    </div>
  </slick>
</template>

<script>
import { apis } from '@/api.js'
import Slick from 'vue-slick'
import ArticleMain from '@/components/_ArticleMain'

export default {
  name: 'SliderArticles',
  data () {
    return {
      url: apis.api.informes3API,
      informes3: ''
    }
  },
  components: {
    Slick,
    ArticleMain
  },
  computed: {
    slickOptions () {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        asNavFor: '.sliderNav'
      }
    }
  },
  methods: {
    getApi () {
      fetch(this.url)
        .then(response => response.json())
        .then(response => {
          this.informes3 = response
        })
    },
    firstWord () {
      Array.from(document.querySelectorAll('.titleFeatured')).forEach(function (ele) {
        let text = ele.innerHTML.split(' ')
        let firstWord = text.shift()
        ele.innerHTML = firstWord + " <span class='titleFeatured--lastWords'>" + text.join(' ') + '</span>'
      })
    }
  },
  created () {
    this.getApi()
  },
  beforeUpdate () {
    if (this.$refs.sliderArticles) {
      this.$refs.sliderArticles.destroy()
    }
  },
  updated () {
    this.$nextTick(function () {
      if (this.$refs.sliderArticles) {
        this.$refs.sliderArticles.create(this.slickOptions)
        this.firstWord()
      }
    })
  }
}
</script>

<style>

</style>
